module.exports = __webpack_public_path__ + "static/media/thanksImg.5c6f8ac4.svg";